import { Component, input } from '@angular/core';
import { RouterLink, RouterLinkActive } from '@angular/router';
import { ClIcon } from '@corelabs/angular/ui';
import { IconNode } from 'lucide';

@Component({
    selector: 'app-menu-item',
    templateUrl: './menu-item.component.html',
    styleUrls: ['./menu-item.component.css'],
    imports: [RouterLink, RouterLinkActive, ClIcon],
})
export class MenuItemComponent {
    label = input.required<string>();
    icon = input<IconNode>();
    routerLink = input.required<string>();
}
